<template>
	<module-field :bind="$props">
		<div class="input-box">
			<selectize v-model="inputVal" :multiple="!isSingle" :settings="settings" :placeholder="field.placeholder">
				<option v-if="isSingle" value="">Select {{ field.name }}</option>
			</selectize>
		</div>
		<div class="input-link"><router-link :to="`/module/${module.slug}/tags/${field.id}`" tabindex="-1"><span class="fa fa-cog"></span>Manage {{ field.name }} Tags</router-link></div>
	</module-field>
</template>

<script>

import CrudField from '@/mixins/CrudField';

export default {

	mixins: [ CrudField ],

	data() {
		return {
			inputVal: this.value[ this.field.slug ] || [],
		};
	},

	computed: {

		settings() {
			return {
				persist: true,
				options: this.dropdownOptions,
				create: (input) => {
					return {
						text: input,
						value: input
					};
				},
				createOnBlur: true,
			};
		},

		dropdownOptions() {
			let tags = (this.tags || []).map(tag => ({
				value: tag.id,
				text: tag.name
			}));

			// tags = tags.concat(this.unsavedTags.map(unsavedTag => ({
			// 	value: unsavedTag,
			// 	text: unsavedTag,
			// })));

			return tags;
		},

		isSingle() {
			return this.field.specific_data === 'single';
		},

		// unsavedTags() {
		// 	return this.inputVal.filter(tag => {
		// 		return typeof this.tags[tag] === 'undefined';
		// 	});
		// },
	},
};
</script>
